export default __webpack_public_path__ + "static/media/product_2.3.080d6248.jpg";